export const validDomainRegex = /^\w+\.{1}\w{2,}$/i
